import React from "react";

import { Helmet } from "react-helmet";

import Header from "../components/header";
import BlogCard from "../components/blog-card";
import FeatureCard from "../components/faq-card";
import Footer from "../components/footer";
import "./faq.css";

const FAQ = (props) => {
  return (
    <div className="faq-container">
      <Helmet>
        <title>FAQ - MabiVCC</title>
        <meta
          property="og:title"
          content="FAQ - Mabinogi Visual Chat Converter"
        />
      </Helmet>
      <Header></Header>
      <div className="faq-blog-posts">
        <div className="faq-container04">
          <FeatureCard
            question="Why is my converted image not showing in game?"
            answer='After converting an image make sure to download it and place it in your Visual Chat folder. You can usually find the Visual Chat folder at "Documents/Mabinogi/Visual Chat".'
          ></FeatureCard>
          <FeatureCard
            question="Why isn't the IGN I type showing in game?"
            answer="Please type your IGN and enable/disable dithering before uploading the image. These options are sent with the image upload as part of the conversion process."
          ></FeatureCard>
          <FeatureCard
            question="Do I need to crop or scale my image down before uploading?"
            answer="Manually cropping or scaling the image before uploading can help improve the converted image quality, but it is not required."
          ></FeatureCard>
          <FeatureCard
            question="What is dithering?"
            answer="Dithering can provide depth to the image and make it look nicer. It works best on more detailed images such as images with many colors and shading. Disabling dithering works best for simple images with no shading."
          ></FeatureCard>
        </div>
      </div>
      <div className="faq-contact">
        <div className="faq-container09">
          <div className="faq-form">
            <h2 className="faq-text18 HeadingOne">
              <span>Have a question that's not listed here?</span>
            </h2>
            <span className="faq-text20 Lead">
              Ping me on discord at svn
            </span>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default FAQ;
